<template>
	<div>
	 <radio-list :question="question" @go-next="goNext(score)"></radio-list>
	</div>
</template>
<script>
  import RadioList from './radioList.vue'
  export default {
    components: { RadioList },
    events: {
      goNext (score, answer) {
        this.$dispatch('changeView', 'q4', score, answer)
      }
    },
    data () {
      return {
        question: {
          title: '年收入',
          qId: 'q3',
          options: [{
            text: '低于3万',
            score: 2,
            aId: 'a1'
          }, {
            text: '3.0万-4.5万',
            score: 5,
            aId: 'a2'
          }, {
            text: '4.5万-5.5万',
            score: 10,
            aId: 'a3'
          }, {
            text: '5.5万-7.5万',
            score: 16,
            aId: 'a4'
          }, {
            text: '7.5万-9.5万',
            score: 21,
            aId: 'a5'
          }, {
            text: '10万以上',
            score: 24,
            aId: 'a6'
          }]
        }
      }
    }
}

</script>



/** WEBPACK FOOTER **
 ** q3.vue?989680c8
 **/